import { FeatureFlagEnum } from '@shared/enums/feature-flag.enum';
import { EnvironmentModel } from '@shared/models/environment.model';

class EnvironmentImpl implements EnvironmentModel {
  production = true;
  sentryDSN = 'https://a29d69920710411f9468febbcbaeb7a6@sentry.io/1471236';

  featureConfig = {
    [FeatureFlagEnum.CreditReportClientTabs]: true,
    [FeatureFlagEnum.CreditReportSettings]: true,
    [FeatureFlagEnum.PreCompletions]: true,
    [FeatureFlagEnum.GlobalSearch]: true,
    [FeatureFlagEnum.EmailPreviewer]: true,
    [FeatureFlagEnum.MabTheme]: false,
    [FeatureFlagEnum.ActivityLog]: true,
  };

  googleCloudPlatformApiKey = 'AIzaSyD9H4bXqHnCUOfGCxwIGMjArzWB5W_r0ks';
  maintenanceUrl = 'https://storage.googleapis.com/dashlyprod-ui-apps-config/config.json';

  urls = {
    clientPortalUrl: 'https://my.dashly.com',
    adviserPortalUrl: 'https://port.dashly.com',
    universalLeadCaptureUrl: 'https://welcome.dashly.com',
    apiUrl: 'https://api.dashly.com',
  };

  companyIds = {
    dashlyCompanyId: '1',
  };

  networkIds = { mabId: '1' };
}

export const environment = new EnvironmentImpl();
